import React, { useState } from "react";

export default function LegalNewsBanner() {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-900 p-4 mb-6 max-w-3xl mx-auto rounded">
      <strong>Latest Legal News:</strong>
      <ul className="list-disc list-inside mt-2 space-y-2">
        <li>
          <a
            href="https://api.sci.gov.in/supremecourt/2022/10885/10885_2022_13_1502_60907_Judgement_22-Apr-2025.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-blue-800 hover:text-blue-900"
          >
            Supreme Court clarifies property rights in joint family cases.
          </a>
        </li>
        <li>
          <button
            onClick={() => setShowDetails(!showDetails)}
            className="underline text-blue-800 hover:text-blue-900"
          >
            Online Land Registry Starts Across India This September – Say Goodbye
            to Office Visits!
          </button>
        </li>
      </ul>

      {showDetails && (
        <div className="mt-4 bg-white border rounded p-4 text-gray-800 max-h-[500px] overflow-y-auto">
          <h2 className="text-lg font-semibold mb-2">Introduction:</h2>
          <p className="mb-3">
            Buying a property is an exciting milestone, but registering it with the
            government is a crucial step that ensures legal ownership and protects
            you from disputes. The good news? Property registration in India has
            become much easier, thanks to the digitization of the process. Many
            states now offer online property registration, saving you time and
            reducing paperwork hassles.
          </p>

          <p className="mb-3">
            In this blog, we’ll walk you through the step-by-step process of
            registering your property online in India. From understanding the
            required documents to calculating registration fees, we’ve got everything
            covered to make your property registration experience stress-free!
          </p>

          <h3 className="font-semibold mt-4">What is Property Registration?</h3>
          <p className="mb-3">
            Property registration is the process of legally recording the ownership
            of a property with the government. Once the property is registered, the
            buyer becomes the official owner, and the government maintains records of
            the transaction. This step is mandatory under the Registration Act of
            1908 to ensure the property’s legal standing.
          </p>

          <h3 className="font-semibold mt-4">Why is Property Registration Important?</h3>
          <ul className="list-disc list-inside mb-3">
            <li>Legal Ownership: Establishes your legal right over the property.</li>
            <li>Prevents Disputes: Protects against fraudulent claims and disputes.</li>
            <li>Government Record: Details entered into official land records.</li>
            <li>Eligibility for Loans: Required when applying for home loans.</li>
          </ul>

          <h3 className="font-semibold mt-4">Step-by-Step Guide to Register Property Online in India</h3>
          <ol className="list-decimal list-inside mb-3 space-y-2">
            <li>
              <strong>Visit the Official Website:</strong> Example portals:
              <br />
              Maharashtra:{" "}
              <a
                href="https://igrmaharashtra.gov.in"
                className="text-blue-700 underline"
                target="_blank"
              >
                igrmaharashtra.gov.in
              </a>{" "}
              | Karnataka:{" "}
              <a
                href="https://kaverionline.karnataka.gov.in"
                className="text-blue-700 underline"
                target="_blank"
              >
                kaverionline.karnataka.gov.in
              </a>{" "}
              | Delhi:{" "}
              <a
                href="https://doris.delhigovt.nic.in"
                className="text-blue-700 underline"
                target="_blank"
              >
                doris.delhigovt.nic.in
              </a>
            </li>
            <li>Create an Account or Log In.</li>
            <li>Fill Out the Application Form (buyer, seller, property details).</li>
            <li>Calculate Stamp Duty & Fees (4–10% depending on state).</li>
            <li>Pay Online via net banking/UPI/cards.</li>
            <li>Book an Appointment at Sub-Registrar’s Office.</li>
            <li>Submit Required Documents (Sale Deed, ID Proof, NOC, etc.).</li>
            <li>Biometric Verification & Final Registration.</li>
            <li>Download the Registered Document.</li>
          </ol>

          <h3 className="font-semibold mt-4">Benefits of Online Property Registration</h3>
          <ul className="list-disc list-inside mb-3">
            <li>Convenience: Complete process from home.</li>
            <li>Time-Saving: Fewer office visits.</li>
            <li>Transparency: Clear fees, timelines, and requirements.</li>
            <li>Reduced Errors: Digital forms minimize mistakes.</li>
          </ul>
        </div>
      )}
    </div>
  );
}
